import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'
import { APP_SYSTEM_VERSION } from '@/constants/appSystemVersion'

export function setDatadogUser(user) {
  if (!user) return
  datadogRum.setUser({
    id: String(user.id),
    name: user.name,
    email: user.email
  })
}

const mode = import.meta.env.MODE
const shouldDisableDatadog =
  mode === 'development' ||
  mode === 'local' ||
  mode === 'test' ||
  String(import.meta.env.VITE_ENABLE_DATADOG || '').toLowerCase() === 'false'

if (!shouldDisableDatadog) {
  const apiUrl = import.meta.env.VITE_API_URL

  datadogRum.init({
    applicationId: '114210c7-dae5-4109-b023-13e8ff4ff6d4',
    clientToken: 'pubcac2d74e842406cc81ad73a4ebe62dc6',
    site: 'datadoghq.com',
    service: 'eyecarebi',
    env: mode,
    version: import.meta.env.VITE_APP_VERSION || APP_SYSTEM_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: apiUrl
      ? [
          {
            match: url => url.includes(apiUrl),
            propagatorTypes: ['datadog', 'tracecontext']
          }
        ]
      : [],
    beforeSend: (event) => {
      if (event.type === 'error') {
        datadogRum.startSessionReplayRecording()
      }
      return true
    }
  })

  datadogLogs.init({
    clientToken: 'pubcac2d74e842406cc81ad73a4ebe62dc6',
    site: 'datadoghq.com',
    service: 'eyecarebi',
    env: mode,
    version: import.meta.env.VITE_APP_VERSION || APP_SYSTEM_VERSION,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['error', 'warn'],
    sessionSampleRate: 100
  })
}
